var Funcionalidades = [
    {
        Perfil: "Matriz",
        PerfilCod: 4,
        Permissoes: [
            { name: "Dashboard", path: "dashboard"},
            { name: "Credenciamento/Gestão Credenciamento", path: "credenciamento"},
            { name: "Vendas/Gestão de Vendas", path: "gestaovendas"},
            { name: "Agenda/Dashboard", path: "dashboardagenda"},
            { name: "Agenda/Agenda", path: "agenda"},
            { name: "Agenda/Gestão de Agenda", path: "gestaoagenda"},
            { name: "Clientes", path: "gestaoclientes"},
            { name: "Estoque/Pedido de Compra", path: "pedidocompra"},
            { name: "Estoque/Gestão de Pedidos", path: "gestaopedidocompra"},
            { name: "Estoque/Recebimento de Compra", path: "recebimentocompra"},
            { name: "Estoque/Cadastro de Fornecedor", path: "cadastrofornecedor"},
            { name: "Royalties/Créditos e Débitos", path: "creditodebitos"},
            { name: "Royalties/Débitos Fixos", path: "debitofixos"},
            { name: "Royalties/Conciliação de Cartões", path: "conciliacaocartao"},
            { name: "Royalties/Fechamento de Royalties", path: "fechamentoroyalties"},
            { name: "Royalties/Confirmação de Pagamento", path: "confirmacaopagamento"},
            { name: "Royalties/Estorno de Royalties", path: "estornoroyalties"},
            { name: "Royalties/Parcelamento de Royalties", path: "parcelamentoroyalties"},
            { name: "Relatórios/Ranking Credenciamento", path: "rankingcredenciamento"},  
            { name: "Relatórios/Analítico de Fechamento", path: "relatorioanaliticofechamento"}, 
            { name: "Relatórios/Log de Fechamento", path: "relatoriologfechamento"}, 
            { name: "Relatórios/Vendas por tipo de Pagamento", path: "relResumoVendasPorTipoPagamento"}, 
            { name: "Relatórios/Créditos e Débitos", path: "relCreditosDebitos"}, 
            { name: "Relatórios/Clínicas Fechadas", path: "relDividasClinicasFechadas"}, 
            { name: "Relatórios/Pagamento Cartão", path: "relPagamentosUra"},
            { name: "Relatórios/Vendas por Pacotes", path: "relPagamentosByPacotes"},
            { name: "Relatórios/Vendas por Serviços", path: "relPagamentosByServicos"},
            { name: "Relatórios/Vendas por Produtos", path: "relPagamentosByProdutos"},
            { name: "Relatórios/Demonstrativo Anual", path: "relDemonstrativoAnual"},
            { name: "Configurações/Cadastro de Grupo Produtos", path: "cadastrogruposproduto"},
            { name: "Configurações/Cadastro de Produtos", path: "cadastroproduto"},
            { name: "Configurações/Cadastro de Especialidade", path: "cadastroespecialidade"},
            { name: "Configurações/Cadastro de Serviços", path: "cadastroservico"},
            { name: "Configurações/Cadastro de Pacote", path: "cadastropacote"},
            { name: "Configurações/Cadastro de Termos", path: "cadastrotermos"},
            { name: "Boletim de Ocorrência", path: "boletimocorrencia"},
            { name: "Financeiro", path: "controlefinanceiro"},
            { name: "Segurança", path: "usuarios"},
            { name: "Perfil", path: "user"},
            { name: "Relatórios/Detalhamento de Contrato", path: "relDetalhamentoContrato"},
            { name: "Relatórios/Boletim de Ocorrência", path: "relBoletimOcorrencia"},
            { name: "Configurações/Grupo Canal Midia", path: "cadastrogrupocanalmidia"},
            { name: "Relatórios/Ranking de Clínicas", path: "relRankingFaturamento"},
            { name: "Relatórios/Ticket Médio Clínicas", path: "relTicketMedio"},
            { name: "Relatórios/Mídia x Vendas", path: "relMidiaxVendas"},
            { name: "Vendas/Alteração de dados da Venda", path: "alteracaovendalist"},
            { name: "Relatórios/Relatórios Personalizados", path: "relPersonalizados"},
            { name: "Relatórios/Relatórios Sistema", path: "relSistema"},
            { name: "Relatórios/Vendas por Cliente", path: "relVendasCliente"},
            { name: "Relatórios/Relatório Exportar Clientes", path: "relExportarCliente"},
        ]
    },
    {
        Perfil: "Estabelecimento",
        PerfilCod: 1,
        Permissoes: [   
            { name: "Dashboard", path: "dashboard"},         
            { name: "Avaliação/Nova Avaliação", path: "avaliacao"},
            { name: "Avaliação/Avaliações Pendentes", path: "avaliacoespendentes"},
            { name: "Vendas/Nova Venda", path: "venda"},
            { name: "Vendas/Vendas em Andamento", path: "vemandamento"},
            { name: "Vendas/Gestão de Vendas", path: "gestaovendas"},
            { name: "Agenda/Agenda", path: "agenda"},            
            { name: "Agenda/Gestão de Agenda", path: "gestaoagenda"},
            { name: "Agenda/Dashboard", path: "dashboardagenda"},
            { name: "Agenda/Bloqueio na Agenda", path: "bloqueioagenda"},
            //{ name: "Agenda/Pesquisa Satisfação", path: "pesquisasatisfacaoagenda"},
            //{ name: "Agenda/Cadastro Estabelecimento", path: "estabelecimentoagenda"},
            { name: "Clientes", path: "gestaoclientes"},
            { name: "Clientes/Gestão de Leads", path: "gestaoleads"},
            { name: "Estoque/Pedido de Compra", path: "pedidocompra"},
            { name: "Estoque/Gestão de Pedidos", path: "gestaopedidocompra"},
            { name: "Estoque/Entrada de Estoque", path: "recebimentocompra"},
            { name: "Estoque/Ajuste de Estoque", path: "ajusteestoque"},
            { name: "Profissionais/Cadastro de Profissionais", path: "cadastroprofissional"},
            { name: "Profissionais/Cadastro de Expedientes", path: "cadastroexpediente"},            
            { name: "Relatórios/Vendas por tipo de Pagamento", path: "relResumoVendasPorTipoPagamento"},            
            { name: "Relatórios/Vendas por Pacotes", path: "relPagamentosByPacotes"},
            { name: "Relatórios/Vendas por Serviços", path: "relPagamentosByServicos"},
            { name: "Relatórios/Vendas por Produtos", path: "relPagamentosByProdutos"},
            { name: "Relatórios/Vendas por Atendente", path: "relVendasByAtendente"},
            { name: "Relatórios/Telegrama de Recebíveis", path: "relTelegramaRecebiveis"},
            { name: "Relatórios/Demonstrativo Anual", path: "relDemonstrativoAnual"},
            { name: "Configurações/Cadastro de Grupo Produtos", path: "cadastroprodutogrupos"},
            { name: "Configurações/Cadastro de Produtos", path: "cadastroprodutos"},
            { name: "Configurações/Cadastro de Especialidade", path: "cadastroespecialidade"},
            { name: "Configurações/Cadastro de Serviços", path: "cadastroservico"},
            { name: "Configurações/Cadastro de Pacote", path: "cadastropacote"},
            { name: "Configurações/Cadastro de Fornecedor", path: "cadastrofornecedor"},
            { name: "Configurações/Cadastro de Profissão", path: "cadastroProfissao"},
            { name: "Configurações/Cadastro de Chave PIX", path: "cadastroChavePIX" },
            { name: "Royalties/Fechamento Royalties", path: "fechamentoroyalties"},
            { name: "Financeiro", path: "controlefinanceiro"},
            { name: "Segurança", path: "usuarios"},
            { name: "Perfil", path: "user"},
            { name: "Relatórios/Detalhamento de Contrato", path: "relDetalhamentoContrato"},
            { name: "Visualizar Setup Agenda", path: "setupAgenda"},
            { name: "Relatórios/Mídia x Vendas", path: "relMidiaxVendas"},
            { name: "Relatórios/Relatórios Personalizados", path: "relPersonalizados"},
            { name: "Relatórios/Relatórios Sistema", path: "relSistema"},
            { name: "Clientes/Lista de Restrições", path: "gestaoListaRestricoes"},
            { name: "Relatórios/Vendas por Cliente", path: "relVendasCliente"},
            { name: "CRM/Cadastro de Campanha", path: "gestaoCampanhas"},
            { name: "CRM/Acompanhamento de Campanha", path: "acompanhamentoCampanhas"},
            { name: "Configurações/Cadastro SMTP", path: "cadastrosmtp"},
            { name: "Relatório/Movimento Estoque", path: "relMovimentoEstoque" },
            { name: "Relatório/Saldo Estoque", path: "relSaldoEstoque" },
        ]
    },
    {
        Perfil: "Profissional",
        PerfilCod: 2,
        Permissoes: [            
            { name: "Avaliação/Nova Avaliação", path: "avaliacao"},
            { name: "Avaliação/Avaliações Pendentes", path: "avaliacoespendentes"},
            { name: "Vendas/Nova Venda", path: "venda"},
            { name: "Vendas/Vendas em Andamento", path: "vemandamento"},
            { name: "Vendas/Gestão de Vendas", path: "gestaovendas"},
            { name: "Agenda/Agenda", path: "agenda"},
            { name: "Agenda/Gestão de Agenda", path: "gestaoagenda"},
            { name: "Clientes", path: "gestaoclientes"},
            { name: "Clientse/Gestão de Leads", path: "gestaoleads"},
            { name: "Estoque/Pedido de Compra", path: "pedidocompra"},
            { name: "Estoque/Gestão de Pedidos", path: "gestaopedidocompra"},
            { name: "Estoque/Entrada de Estoque", path: "recebimentocompra"},
            { name: "Estoque/Ajuste de Estoque", path: "ajusteestoque"},
            { name: "Profissionais/Cadastro de Profissionais", path: "cadastroprofissional"},
            { name: "Profissionais/Cadastro de Expedientes", path: "cadastroexpediente"},
            { name: "Configurações/Cadastro de Grupo Produtos", path: "cadastroprodutogrupos"},
            { name: "Configurações/Cadastro de Produtos", path: "cadastroprodutos"},
            { name: "Configurações/Cadastro de Especialidade", path: "cadastroespecialidade"},
            { name: "Configurações/Cadastro de Serviços", path: "cadastroservico"},
            { name: "Configurações/Cadastro de Pacote", path: "cadastropacote"},
            { name: "Configurações/Cadastro de Fornecedor", path: "cadastrofornecedor"},
            { name: "Configurações/Bloqueio na Agenda", path: "bloqueioagenda"},
            { name: "Royalties/Fechamento Royalties", path: "fechamentoroyalties"},            
            { name: "Financeiro", path: "controlefinanceiro"},
            { name: "Segurança", path: "usuarios"},
            { name: "Perfil", path: "user"},
            { name: "Visualizar Setup Agenda", path: "setupAgenda"}
             
        ]
    },
    {
        Perfil: "Cliente",
        PerfilCod: 3,
        Permissoes: [],
    }
];
export default Funcionalidades;